<template>
  <div class="room gas-clamp">
    <refresh-block @refreshData="refreshData"></refresh-block>
    <div class="main-cable up-stream">
      <div class="cable-title">
        <h2>上游主缆</h2>
      </div>
      <div
        class="cable-main"
        v-loading="loading"
      >
        <div class="legend">
          <div class="supply">送气夹</div>
          <div class="exhaust">排气夹</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">广州</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">东莞(海鸥岛)</span>
        </div>
        <div class="cable-img">
          <el-tooltip
            class="station-block station-block-1"
            content="1号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/daSha/prepStation1/anchorAfan"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-2"
            content="5号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/daSha/prepStation5/prepStationBig"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-3"
            content="6号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/daSha/prepStation6/prepStationBig"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-4"
            content="3号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/daSha/prepStation3/anchorAfan"
            ></router-link>
          </el-tooltip>
          <div
            class="clip"
            :class="[item.className,`ex${$index+1}`]"
            :title="item.name"
            :key="`top-item-${$index}`"
            v-for="(item,$index) in topList"
          >
            <div
              class="state-info"
              :class="[item.opsName,item.errorLevel]"
            >
              <p>{{item.minName}}</p>
              <p class="airHumidity">{{item.list[0].value}}%</p>
              <p class="airTemperature">{{item.list[1].value}}°C</p>
              <p class="airPressure">{{item.list[2].value}}Pa</p>
              <p
                class="airFlow"
                v-if="item.list[3]"
              >{{item.list[3].value}}m³/h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-cable up-stream">
      <div class="cable-title">
        <h2>下游主缆</h2>
      </div>
      <div
        class="cable-main"
        v-loading="loading"
      >
        <div class="legend">
          <div class="supply">送气夹</div>
          <div class="exhaust">排气夹</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">广州</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">东莞(海鸥岛)</span>
        </div>
        <div class="cable-img">
          <el-tooltip
            class="station-block station-block-1"
            content="2号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/daSha/prepStation2/anchorAfan"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-2"
            content="5号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/daSha/prepStation5/prepStationBig"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-3"
            content="6号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/daSha/prepStation6/prepStationBig"
            ></router-link>
          </el-tooltip>
          <el-tooltip
            class="station-block station-block-4"
            content="4号制备站"
            effect="light"
            placement="top"
          >
            <router-link
              class="iconfont iconshebei"
              to="/daSha/prepStation4/anchorAfan"
            ></router-link>
          </el-tooltip>
          <div
            class="clip"
            :class="[item.className,`ex${$index+1}`]"
            :title="item.name"
            :key="`bottom-item-${$index}`"
            v-for="(item,$index) in bottomList"
          >
            <div
              class="state-info"
              :class="[item.opsName,item.errorLevel]"
            >
              <p>{{item.minName}}</p>
              <p class="airHumidity">{{item.list[0].value}}%</p>
              <p class="airTemperature">{{item.list[1].value}}°C</p>
              <p class="airPressure">{{item.list[2].value}}Pa</p>
              <p
                class="airFlow"
                v-if="item.list[3]"
              >{{item.list[3].value}}m³/h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'gasClamp',
  data() {
    return {
      loading: true,
      topList: [
        {
          name: '大沙1#制备站SW1',
          minName: '排气/SW1',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SW1气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW1气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW1气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙1#制备站SW2',
          minName: '送气/SW2',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SW2气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW2气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW2气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SW2气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙1#制备站SW3',
          minName: '排气/SW3',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SW3气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW3气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW3气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站SW4',
          minName: '排气/SW4',
          className: 'exhaust',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SW4气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW4气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW4气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站SW5',
          minName: '送气/SW5',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SW5气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW5气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW5气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SW5气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站SW6',
          minName: '排气/SW6',
          className: 'exhaust',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SW6气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW6气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW6气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站SW7',
          minName: '送气/SW7',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SW7气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW7气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW7气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SW7气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站SW8',
          minName: '排气/SW8',
          className: 'exhaust',
          opsName: 'bottom-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'SW8气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW8气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW8气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙6#制备站SW9',
          minName: '送气/SW9',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SW9气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW9气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW9气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SW9气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙6#制备站SW10',
          minName: '排气/SW10',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'SW10气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW10气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW10气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙6#制备站SW11',
          minName: '送气/SW11',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SW11气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW11气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW11气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SW11气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙6#制备站SW12',
          minName: '排气/SW12',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'SW12气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW12气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW12气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙3#制备站SW13',
          minName: '排气/SW13',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SW13气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW13气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW13气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙3#制备站SW14',
          minName: '送气/SW14',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SW14气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW14气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW14气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'SW14气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙3#制备站SW15',
          minName: '排气/SW15',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'SW15气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'SW15气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'SW15气夹压力(Pa)',
              value: null
            }
          ]
        }
      ],
      bottomList: [
        {
          name: '大沙2#制备站XE1',
          minName: '排气/XE1',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XE1气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE1气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE1气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙2#制备站XE2',
          minName: '送气/XE2',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XE2气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE2气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE2气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XE2气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙2#制备站XE3',
          minName: '排气/XE3',
          className: 'exhaust',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XE3气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE3气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE3气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站XE4',
          minName: '排气/XE4',
          className: 'exhaust',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XE4气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE4气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE4气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站XE5',
          minName: '送气/XE5',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XE5气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE5气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE5气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XE5气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站XE6',
          minName: '排气/XE6',
          className: 'exhaust',
          opsName: 'left-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XE6气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE46气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE6气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站XE7',
          minName: '送气/XE7',
          className: 'supply',
          opsName: 'right-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XE7气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE7气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE7气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XE7气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙5#制备站XE8',
          minName: '排气/XE8',
          className: 'exhaust',
          opsName: 'bottom-pos',
          errorLevel: '',
          list: [
            {
              deviceName: 'XE8气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE8气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE8气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙6#制备站XE9',
          minName: '送气/XE9',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XE9气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE9气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE9气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XE9气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙6#制备站XE10',
          minName: '排气/XE10',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'XE10气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE10气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE10气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙6#制备站XE11',
          minName: '送气/XE11',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XE11气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE11气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE11气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XE11气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙6#制备站XE12',
          minName: '排气/XE12',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'right-pos',
          list: [
            {
              deviceName: 'XE12气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE12气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE12气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙4#制备站XE13',
          minName: '排气/XE13',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XE13气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE13气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE13气夹压力(Pa)',
              value: null
            }
          ]
        },
        {
          name: '大沙4#制备站XE14',
          minName: '送气/XE14',
          className: 'supply',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XE14气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE14气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE14气夹压力(Pa)',
              value: null
            },
            {
              deviceName: 'XE14气夹流量(m?/h)',
              value: null
            }
          ]
        },
        {
          name: '大沙4#制备站XE15',
          minName: '排气/XE15',
          className: 'exhaust',
          errorLevel: '',
          opsName: 'left-pos',
          list: [
            {
              deviceName: 'XE15气夹湿度(%)',
              value: null
            },
            {
              deviceName: 'XE15气夹温度(℃)',
              value: null
            },
            {
              deviceName: 'XE15气夹压力(Pa)',
              value: null
            }
          ]
        }
      ],
      timeFunc: null,
      deviceList: [
        {
          deviceId: '6bf71886-79e3-4464-a9f1-cdd366a97848',
          deviceName: 'SW10气夹湿度(%)'
        },
        {
          deviceId: '36499dc3-f2c3-4c82-bae7-8a9116f49a36',
          deviceName: 'SW11气夹湿度(%)'
        },
        {
          deviceId: '0a139e52-7cd4-43c6-9a04-ec114235e042',
          deviceName: 'SW12气夹湿度(%)'
        },
        {
          deviceId: '82094816-198a-4339-bacc-f18049dcabac',
          deviceName: 'SW13气夹湿度(%)'
        },
        {
          deviceId: '2fdcd48a-04e3-46db-b7e5-0ea727071da4',
          deviceName: 'SW14气夹湿度(%)'
        },
        {
          deviceId: '9bade95a-d016-4615-bf9e-60f9d52c9e7d',
          deviceName: 'SW15气夹湿度(%)'
        },
        {
          deviceId: '5f023699-e792-433d-9670-c01e628c0ea9',
          deviceName: 'SW1气夹湿度(%)'
        },
        {
          deviceId: '87bc2a8b-768a-488e-80ca-e2920ffda247',
          deviceName: 'SW2气夹湿度(%)'
        },
        {
          deviceId: 'd53457be-5e7e-4569-9f6d-f2624ac13af5',
          deviceName: 'SW3气夹湿度(%)'
        },
        {
          deviceId: '69b3057c-b9bd-4019-b14d-bad90c0101e7',
          deviceName: 'SW4气夹湿度(%)'
        },
        {
          deviceId: '16f80979-25fa-442d-b160-1b2db78daf19',
          deviceName: 'SW5气夹湿度(%)'
        },
        {
          deviceId: 'c5f99193-d3f1-415b-a086-52f6205f15ec',
          deviceName: 'SW6气夹湿度(%)'
        },
        {
          deviceId: '020aaf14-2cc7-4d4f-89c6-ec2ae6cadac7',
          deviceName: 'SW7气夹湿度(%)'
        },
        {
          deviceId: 'e7c128e9-3eff-4df8-9221-78a0a4826443',
          deviceName: 'SW8气夹湿度(%)'
        },
        {
          deviceId: '66d8e7a4-9194-414b-b20e-9c8f4e85bff2',
          deviceName: 'SW9气夹湿度(%)'
        },
        {
          deviceId: 'd62b83b5-19cb-4fdf-9c4e-5b9d7673aef9',
          deviceName: 'XE10气夹湿度(%)'
        },
        {
          deviceId: 'cef27c4c-9f94-4ed6-8a80-d7ea1caa1285',
          deviceName: 'XE11气夹湿度(%)'
        },
        {
          deviceId: '40e02b6e-b331-4959-8f03-2a5a98050986',
          deviceName: 'XE12气夹湿度(%)'
        },
        {
          deviceId: 'a710de61-a3df-4d8c-b676-ac1baaf664af',
          deviceName: 'XE13气夹湿度(%)'
        },
        {
          deviceId: '4e049bd9-ea78-4889-a374-d5ae391ce737',
          deviceName: 'XE14气夹湿度(%)'
        },
        {
          deviceId: 'cbb89aa6-3b9b-4063-8fcb-056c749e093c',
          deviceName: 'XE15气夹湿度(%)'
        },
        {
          deviceId: '3f7a48c4-039c-4205-8da2-0dd01ac178af',
          deviceName: 'XE1气夹湿度(%)'
        },
        {
          deviceId: 'cecb9d8b-153e-4849-bb8d-15c5f15d00e1',
          deviceName: 'XE2气夹湿度(%)'
        },
        {
          deviceId: 'd7140be5-30ad-434c-99fa-5d4622121837',
          deviceName: 'XE3气夹湿度(%)'
        },
        {
          deviceId: '67251dc8-28eb-4c4f-a0e7-8062489d5345',
          deviceName: 'XE4气夹湿度(%)'
        },
        {
          deviceId: '2cde0818-2c18-4595-a20b-07b9bc23e32a',
          deviceName: 'XE5气夹湿度(%)'
        },
        {
          deviceId: '17f21cd3-becb-4a58-a137-fb6271d063f6',
          deviceName: 'XE6气夹湿度(%)'
        },
        {
          deviceId: '86c48f4e-d2f8-45e5-98be-8aaf8458fef1',
          deviceName: 'XE7气夹湿度(%)'
        },
        {
          deviceId: '22fecedf-d900-416d-a771-901416a8710a',
          deviceName: 'XE8气夹湿度(%)'
        },
        {
          deviceId: 'eb79eb99-c1ce-401b-9622-7a82577e768c',
          deviceName: 'XE9气夹湿度(%)'
        },
        {
          deviceId: '1398a830-0bff-4028-9d0c-9db8ef4442ac',
          deviceName: 'SW10气夹温度(℃)'
        },
        {
          deviceId: '76872ba2-6bca-473f-9aee-6fae83f3a889',
          deviceName: 'SW11气夹温度(℃)'
        },
        {
          deviceId: '28fed923-2081-48a3-ab16-dc73a0c536b7',
          deviceName: 'SW12气夹温度(℃)'
        },
        {
          deviceId: '05bd5831-35f7-4176-8767-971eb8d27c56',
          deviceName: 'SW13气夹温度(℃)'
        },
        {
          deviceId: '284a5952-915b-4736-bf0b-4b5b0ba74c9b',
          deviceName: 'SW14气夹温度(℃)'
        },
        {
          deviceId: '491c98eb-eee1-49af-8fe5-21d7259001fb',
          deviceName: 'SW15气夹温度(℃)'
        },
        {
          deviceId: '3c0fa9b8-3770-4819-bc62-cc23832fa094',
          deviceName: 'SW1气夹温度(℃)'
        },
        {
          deviceId: '321fe66e-6f3a-40e6-beea-9f65dfee5df7',
          deviceName: 'SW2气夹温度(℃)'
        },
        {
          deviceId: '0c4b9400-5e1c-4050-a23f-03c23fbc151a',
          deviceName: 'SW3气夹温度(℃)'
        },
        {
          deviceId: '3398eb6f-4fc1-4efd-8efb-dfdb3b518b82',
          deviceName: 'SW4气夹温度(℃)'
        },
        {
          deviceId: '45f51a03-cfff-4c5f-b911-7c15ca3857b9',
          deviceName: 'SW5气夹温度(℃)'
        },
        {
          deviceId: 'dda09dde-6e8e-4f9b-ade4-a6b62a2168a6',
          deviceName: 'SW6气夹温度(℃)'
        },
        {
          deviceId: 'a1947131-4362-4ac7-a71e-432296108275',
          deviceName: 'SW7气夹温度(℃)'
        },
        {
          deviceId: 'a1852872-8b38-412c-bb28-2cb73a221da2',
          deviceName: 'SW8气夹温度(℃)'
        },
        {
          deviceId: 'b88786db-6e84-4a05-aa6a-952cabac2cb8',
          deviceName: 'SW9气夹温度(℃)'
        },
        {
          deviceId: 'd3b5d0ae-ef21-4ea0-bccd-aa2974af573f',
          deviceName: 'XE10气夹温度(℃)'
        },
        {
          deviceId: '60f12644-cdb7-49f0-98a0-c549d8b0c754',
          deviceName: 'XE11气夹温度(℃)'
        },
        {
          deviceId: '9a765a51-208f-4748-b1d1-118ed66fe982',
          deviceName: 'XE12气夹温度(℃)'
        },
        {
          deviceId: 'a6c66951-37bc-45cc-b644-ff10d72070c2',
          deviceName: 'XE13气夹温度(℃)'
        },
        {
          deviceId: '7199f218-e093-47fa-a4fd-1a3ac2f7bb23',
          deviceName: 'XE14气夹温度(℃)'
        },
        {
          deviceId: '1250b866-9041-43ae-b2b0-9002db7f63a1',
          deviceName: 'XE15气夹温度(℃)'
        },
        {
          deviceId: 'b1da36c0-0c70-458f-87ad-6847ee19d16c',
          deviceName: 'XE1气夹温度(℃)'
        },
        {
          deviceId: 'c827f226-747f-4cdc-bb27-2f8cd79d53b8',
          deviceName: 'XE2气夹温度(℃)'
        },
        {
          deviceId: '08ae911a-6138-4497-8d22-f2608a83823b',
          deviceName: 'XE3气夹温度(℃)'
        },
        {
          deviceId: '01f895ab-1fa1-4a90-a88b-f0f46a1aca6f',
          deviceName: 'XE46气夹温度(℃)'
        },
        {
          deviceId: '712455a6-4535-41a3-9e59-3874d6646a2c',
          deviceName: 'XE4气夹温度(℃)'
        },
        {
          deviceId: 'fc571bba-ee01-4420-ac0a-43dba7a81837',
          deviceName: 'XE5气夹温度(℃)'
        },
        {
          deviceId: 'ddaab3ec-f222-4cc3-9dae-b63708ea3956',
          deviceName: 'XE7气夹温度(℃)'
        },
        {
          deviceId: 'fb84b1ef-0706-4195-a510-8494615e5678',
          deviceName: 'XE8气夹温度(℃)'
        },
        {
          deviceId: '309ce352-ff4c-4f72-9511-224bfb8c2b8c',
          deviceName: 'XE9气夹温度(℃)'
        },
        {
          deviceId: 'a38f075c-3e4f-467d-8e3b-fb33959b4fa5',
          deviceName: 'SW11气夹流量(m?/h)'
        },
        {
          deviceId: 'b94d4bad-b02e-4ed6-bbbf-54e63273f4a5',
          deviceName: 'SW14气夹流量(m?/h)'
        },
        {
          deviceId: 'e3a06278-2dd4-47e1-b86d-2d31a138594e',
          deviceName: 'SW2气夹流量(m?/h)'
        },
        {
          deviceId: 'c90d57b6-4f6f-4745-adf5-057f5e4da834',
          deviceName: 'SW5气夹流量(m?/h)'
        },
        {
          deviceId: 'c732a183-850c-4c31-9ff0-e9ec070f0403',
          deviceName: 'SW7气夹流量(m?/h)'
        },
        {
          deviceId: 'e0a8fe32-31e7-4195-8369-28a8adca8bd1',
          deviceName: 'SW9气夹流量(m?/h)'
        },
        {
          deviceId: '76f56cc1-46b1-4fc3-9fed-93a270df624a',
          deviceName: 'XE11气夹流量(m?/h)'
        },
        {
          deviceId: '7edfe253-d4a1-48cf-9307-1500c30f6b41',
          deviceName: 'XE14气夹流量(m?/h)'
        },
        {
          deviceId: '96c58040-3d3c-4d61-9576-f9f2e90c3e25',
          deviceName: 'XE2气夹流量(m?/h)'
        },
        {
          deviceId: 'e5f76b9d-641f-47f2-bd22-ff844b29c67f',
          deviceName: 'XE5气夹流量(m?/h)'
        },
        {
          deviceId: '78bd2dfa-0db9-4eec-9cd7-30f6f326d089',
          deviceName: 'XE7气夹流量(m?/h)'
        },
        {
          deviceId: '3f24d8b2-07ea-49b5-8de9-d2243bfbea3d',
          deviceName: 'XE9气夹流量(m?/h)'
        },
        {
          deviceId: 'dfc33a69-5fa9-4fa4-a52d-998d30a35650',
          deviceName: 'SW10气夹压力(Pa)'
        },
        {
          deviceId: '2bee99ab-8d4d-48cd-a727-c82ffb78436d',
          deviceName: 'SW11气夹压力(Pa)'
        },
        {
          deviceId: 'ab1443de-0295-4111-a1cd-a738ae208ea7',
          deviceName: 'SW12气夹压力(Pa)'
        },
        {
          deviceId: '42675477-e38e-4f23-923f-796176b13de0',
          deviceName: 'SW13气夹压力(Pa)'
        },
        {
          deviceId: '34a555c2-3ff9-4320-b985-21c59198b2de',
          deviceName: 'SW14气夹压力(Pa)'
        },
        {
          deviceId: '2efd2056-d1b6-4df7-958d-5221bd8b4ab8',
          deviceName: 'SW15气夹压力(Pa)'
        },
        {
          deviceId: 'f358ff2a-b777-4274-a8cc-9f5388aa04b2',
          deviceName: 'SW1气夹压力(Pa)'
        },
        {
          deviceId: 'cdab06b4-eb47-44ee-b89a-a0aff2ee2b9c',
          deviceName: 'SW2气夹压力(Pa)'
        },
        {
          deviceId: '8e214d80-cfe5-4875-b0bf-61e91a89c483',
          deviceName: 'SW3气夹压力(Pa)'
        },
        {
          deviceId: '69d388a0-48f6-4da7-923e-9c3e4052d216',
          deviceName: 'SW4气夹压力(Pa)'
        },
        {
          deviceId: '7f32ce85-31a5-4922-9893-832b3042abd9',
          deviceName: 'SW5气夹压力(Pa)'
        },
        {
          deviceId: '28f24757-9d90-48ae-90ac-bbe826db4b24',
          deviceName: 'SW6气夹压力(Pa)'
        },
        {
          deviceId: '478f6e7a-4223-4d03-b836-a3dbc4db054f',
          deviceName: 'SW7气夹压力(Pa)'
        },
        {
          deviceId: '9063b31d-a8db-4c41-adb7-6e52515261a7',
          deviceName: 'SW8气夹压力(Pa)'
        },
        {
          deviceId: 'bf17cbc4-06c5-4253-9d1b-f37ba9095fa0',
          deviceName: 'SW9气夹压力(Pa)'
        },
        {
          deviceId: '87fa3b7a-578a-4802-b832-696570993418',
          deviceName: 'XE10气夹压力(Pa)'
        },
        {
          deviceId: '2911be61-f90f-42bc-b94a-988470302bc1',
          deviceName: 'XE11气夹压力(Pa)'
        },
        {
          deviceId: 'c334e8b3-b5e6-49c9-a841-31a1465f1003',
          deviceName: 'XE12气夹压力(Pa)'
        },
        {
          deviceId: 'f63eed1d-8cca-4ba1-9a79-c39a0cc47abd',
          deviceName: 'XE13气夹压力(Pa)'
        },
        {
          deviceId: '020ce7f1-0801-43ea-9abc-9eed200e0b3b',
          deviceName: 'XE14气夹压力(Pa)'
        },
        {
          deviceId: '77445524-4b28-433d-9b0c-077119e0d1e5',
          deviceName: 'XE15气夹压力(Pa)'
        },
        {
          deviceId: 'eca293f8-f85a-40d6-a01f-bcce3c505913',
          deviceName: 'XE1气夹压力(Pa)'
        },
        {
          deviceId: '89a1a1ed-19b5-4620-a130-3fe59bf28950',
          deviceName: 'XE2气夹压力(Pa)'
        },
        {
          deviceId: 'f6552572-c994-48f6-b792-ac3692af9e60',
          deviceName: 'XE3气夹压力(Pa)'
        },
        {
          deviceId: '05c55f2a-dae5-42ec-81a4-7414f3dbe684',
          deviceName: 'XE4气夹压力(Pa)'
        },
        {
          deviceId: 'ccb16894-7400-436a-84f7-2b3c52dac17b',
          deviceName: 'XE5气夹压力(Pa)'
        },
        {
          deviceId: 'd3b63200-9c14-4581-b2d6-c265dbd86905',
          deviceName: 'XE6气夹压力(Pa)'
        },
        {
          deviceId: 'c59ae7a5-ec6b-4bdb-bf8e-9e1d8268b072',
          deviceName: 'XE7气夹压力(Pa)'
        },
        {
          deviceId: '5b886028-83d5-420b-9cca-3e05dc60ffea',
          deviceName: 'XE8气夹压力(Pa)'
        },
        {
          deviceId: '2a48c65a-3e7c-4926-a4cc-143e8f754cf0',
          deviceName: 'XE9气夹压力(Pa)'
        }
      ]
    }
  },
  created() {
    this.getDevice()
    this.timeFunc = setInterval(() => {
      this.getDevice()
    }, this.REFRESH_SECOND)
  },
  destroyed() {
    clearInterval(this.timeFunc)
    this.timeFunc = null
  },
  methods: {
    refreshData() {
      this.getDevice()
      this.loading = true
      clearInterval(this.timer)
      this.timeFunc = setInterval(() => {
        this.getDevice()
      }, this.REFRESH_SECOND)
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getDevice() {
      this.$http
        .get(
          `/deviceData/Station?stationId=de2c656d-bd41-4905-89f0-cbc1eb634708`
        )
        .then(res => {
          this.$store.commit('setLastRefreshTime')
          this.loading = false
          const __data = res.data
          this.topList.forEach(val => {
            let errorLevelText = 'Normal'
            val.list.forEach(item => {
              const { value, errorLevel } = this.findDeviceData(
                __data,
                item.deviceName
              )
              item.value = value
              if (errorLevelText !== 'Error') {
                if (errorLevel !== 'Normal') {
                  errorLevelText = errorLevel
                }
              }
            })
            val.errorLevel = errorLevelText
          })
          this.bottomList.forEach(val => {
            let errorLevelText = 'Normal'
            val.list.forEach(item => {
              const { value, errorLevel } = this.findDeviceData(
                __data,
                item.deviceName
              )
              item.value = value
              if (errorLevelText !== 'Error') {
                if (errorLevel !== 'Normal') {
                  errorLevelText = errorLevel
                }
              }
            })
            val.errorLevel = errorLevelText
          })
        })
    }
  }
}
</script>
<style scoped lang="scss">
.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height:370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 60px;

      .legend {
        position: absolute;
        left: 25px;
        top: 25px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .supply:after {
          background: #3376c7;
        }

        .circle::after {
          background: #b33c86;
        }

        .exhaust:after {
          background: #c7798b;
        }

        .exhaust1:after {
          background: #f2bd42;
        }
      }

      .dir {
        position: absolute;
        top: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 100px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 100px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1400px;
        height: 250px;
        background: url("../../assets/image/dasha/大沙布局-无背景.png")
          no-repeat;
        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
          &-1 {
            top: 151px;
            left: 173px;
          }
          &-2 {
            top: 137px;
            left: 217px;
          }
          &-3 {
            top: 140px;
            left: 966px;
          }
          &-4 {
            top: 154px;
            left: 1228px;
          }
        }
        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 70px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 80px;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            & > p {
              margin: 0;
              &:first-child {
                font-size: 13px;
                white-space: nowrap;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              top: auto;
              bottom: -5px;
              left: 43%;
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.exhaust {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(253, 247, 250, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.circle {
            background: #b33c86;
            &:after,
            &:before {
              background: #b33c86;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #b33c86;
              }
            }
          }

          &.supply {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }

          &.exhaust1 {
            background: #f2bd42;

            &:after,
            &:before {
              background: #f2bd42;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #f2bd42;
              }
            }
          }
        }

        .ex1 {
          top: 150px;
          left: 200px;
          &::before {
            top: -34px;
            left: -33px;
            transform: rotate(79deg);
          }
          &::after {
            top: -68px;
            left: -19px;
          }
          .state-info {
            right: 37px;
            top: -66px;
          }
        }

        .ex2 {
          top: 114px;
          left: 285px;
          &::before {
            top: 74px;
            left: -74px;
            width: 130px;
            transform: rotate(107deg);
          }

          &::after {
            top: 135px;
            left: -44px;
          }

          .state-info {
            right: 62px;
            top: 136px;
          }
        }

        .ex3 {
          top: 85px;
          left: 357px;

          &::before {
            top: -33px;
            left: -38px;
            transform: rotate(71deg);
          }

          &::after {
            top: -67px;
            left: -28px;
          }

          .state-info {
            right: 45px;
            top: -66px;
          }
        }

        .ex4 {
          top: 85px;
          left: 386px;
          &::before {
            bottom: 48px;
            left: -20px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -98px;
            top: -66px;
          }
        }

        .ex5 {
          top: 110px;
          left: 455px;
          &::before {
            top: 76px;
            right: -46px;
            width: 126px;
            transform: rotate(-80deg);
          }

          &::after {
            top: 138px;
            left: -32px;
            width: 20px;
          }

          .state-info {
            right: 45px;
            top: 139px;
          }
        }

        .ex6 {
          top: 125px;
          left: 524px;
          &::before {
            bottom: 48px;
            left: -20px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -98px;
            top: -66px;
          }
        }

        .ex7 {
          top: 138px;
          left: 604px;
          &::before {
            top: 63px;
            width: 100px;
            right: -33px;
            transform: rotate(-79deg);
          }

          &::after {
            top: 111px;
            left: -26px;
          }

          .state-info {
            right: 43px;
            top: 112px;
          }
        }

        .ex8 {
          top: 142px;
          left: 686px;
          &::before {
            top: -10px;
            left: -6px;
            width: 28px;
            transform: rotate(90deg);
          }

          &::after {
            display: none;
            left: 21px;
          }

          .state-info {
            left: 50%;
            top: -109px;
            transform: translateX(-49%);
          }
        }

        .ex9 {
          top: 138px;
          left: 769px;
          &::before {
            top: 63px;
            width: 100px;
            left: -33px;
            transform: rotate(79deg);
          }

          &::after {
            top: 111px;
            left: 27px;
          }

          .state-info {
            left: 44px;
            top: 112px;
          }
        }

        .ex10 {
          top: 125px;
          left: 839px;
          &::before {
            bottom: 48px;
            right: -26px;
            transform: rotate(87deg);
          }

          &::after {
            top: -68px;
            left: -10px;
          }

          .state-info {
            right: 21px;
            top: -66px;
          }
        }

        .ex11 {
          top: 106px;
          left: 910px;
          &::before {
            top: 79px;
            left: -46px;
            width: 133px;
            transform: rotate(80deg);
          }

          &::after {
            bottom: -130px;
            left: 33px;
          }

          .state-info {
            left: 50px;
            top: 145px;
          }
        }
        .ex12 {
          top: 85px;
          left: 968px;

          &::before {
            top: -33px;
            left: -38px;
            transform: rotate(71deg);
          }

          &::after {
            top: -67px;
            left: -28px;
          }

          .state-info {
            right: 45px;
            top: -66px;
          }
        }

        .ex13 {
          top: 85px;
          left: 999px;
          &::before {
            bottom: 48px;
            left: -20px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -98px;
            top: -66px;
          }
        }

        .ex14 {
          top: 124px;
          left: 1109px;
          &::before {
            top: 70px;
            width: 116px;
            left: -44px;
            transform: rotate(82deg);
          }

          &::after {
            bottom: -112px;
            left: 23px;
          }

          .state-info {
            left: 40px;
            top: 127px;
          }
        }

        .ex15 {
          top: 153px;
          left: 1210px;
          &::before {
            top: -34px;
            right: -33px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -68px;
            right: -19px;
          }

          .state-info {
            left: 37px;
            top: -66px;
          }
        }
        .ex16 {
          top: 150px;
          left: 1133px;
          &::before {
            bottom: -63px;
            right: -75px;
            width: 130px;
            transform: rotate(74deg);
          }
          &::after {
            bottom: -125px;
            right: -42px;
          }
          .state-info {
            left: 58px;
            top: 139px;
          }
        }
        .ex17 {
          top: 188px;
          left: 1223px;
          &::before {
            bottom: 61px;
            right: -56px;
            width: 100px;
            transform: rotate(-74deg);
          }
          &::after {
            bottom: 109px;
            right: -34px;
          }
          .state-info {
            right: -111px;
            top: -93px;
          }
        }
      }
    }
  }
}
</style>
